<template>
  <a @click="stayPlace" class="button-primary block button-icon icon-left">
    <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
    <span>滞在地に指定する</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom'
    })
  },
  methods: {
    stayPlace: function () {
      const params = {
        place: {
          name: this.place.name,
          location: this.place.location
        }
      }
      this.$store.dispatch('user/setStayPlace', params)
      this.$router.push({ path: '/plans' })
    }
  }
}
</script>
